import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Transition as _Transition, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "group"
}
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = { style: {"text-align":"right","padding":"10px","margin":"0","background":"#1e1e2d","color":"white"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScaleLoader = _resolveComponent("ScaleLoader")!
  const _component_ExportButtons = _resolveComponent("ExportButtons")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.flipped)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-custom",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.flipped = !_ctx.flipped))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "bi bi-box-arrow-right" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ScaleLoader, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.flipped)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ExportButtons, {
            csv: _ctx.exportGridsToExcel,
            pdf: _ctx.exportGridsToPdf,
            xlsx: _ctx.exportGridsToExcel
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createElementVNode("button", {
                  class: "btn btn-custom",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.flipped = !_ctx.flipped))
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "bi bi-box-arrow-left" }, null, -1)
                ]))])
              ], true)
            ]),
            _: 3
          }, 8, ["csv", "pdf", "xlsx"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "rotateY" }, {
      default: _withCtx(() => [
        (!_ctx.flipped && _ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.windowWidth > 1500 ? 'col-sm-4' : 'col-sm-6')
              }, [
                _createVNode(_component_Card, {
                  badges: 2,
                  "info-badge-description": [_ctx.dateFrom, _ctx.dateTo],
                  "info-badge-title": [_ctx.$t('components.history.summary.from'), _ctx.$t('components.history.summary.to')],
                  status: _ctx.$t('components.history.summary.dateRange'),
                  icon: "bi bi-calendar3-range"
                }, null, 8, ["info-badge-description", "info-badge-title", "status"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.windowWidth > 1500 ? 'col-sm-4' : 'col-sm-6')
              }, [
                (_ctx.hasCustomName)
                  ? (_openBlock(), _createBlock(_component_Card, {
                      key: 0,
                      badges: 2,
                      "info-badge-description": [_ctx.vehicle.registration, _ctx.vehicle.vars.name],
                      "info-badge-title": [_ctx.$t('components.history.summary.registration'), _ctx.$t('components.history.summary.customName')],
                      status: _ctx.$t('components.history.summary.vehicle'),
                      icon: "bi bi-truck"
                    }, null, 8, ["info-badge-description", "info-badge-title", "status"]))
                  : (_openBlock(), _createBlock(_component_Card, {
                      key: 1,
                      badges: 1,
                      "info-badge-description": [_ctx.vehicle.registration],
                      "info-badge-title": [_ctx.$t('components.history.summary.registration')],
                      status: _ctx.$t('components.history.summary.vehicle'),
                      icon: "bi bi-truck"
                    }, null, 8, ["info-badge-description", "info-badge-title", "status"]))
              ], 2),
              (_ctx.hasCan)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.windowWidth > 1500 ? 'col-sm-4' : 'col-sm-6')
                  }, [
                    _createVNode(_component_Card, {
                      badges: 2,
                      "info-badge-description": [_ctx.store.map_distance + ' [km]', _ctx.store.can_distance + ' [km]'],
                      "info-badge-title": [_ctx.$t('components.history.summary.fromMap'), _ctx.$t('components.history.summary.fromCan')],
                      status: _ctx.$t('components.history.summary.distance'),
                      icon: "bi bi-bezier2"
                    }, null, 8, ["info-badge-description", "info-badge-title", "status"])
                  ], 2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(_ctx.windowWidth > 1500 ? 'col-sm-4' : 'col-sm-6')
                  }, [
                    (_ctx.store.map_distance > 0)
                      ? (_openBlock(), _createBlock(_component_Card, {
                          key: 0,
                          badges: 1,
                          "info-badge-description": [_ctx.store.map_distance + ' [km]'],
                          "info-badge-title": [_ctx.$t('components.history.summary.fromMap')],
                          status: _ctx.$t('components.history.summary.distance'),
                          icon: "bi bi-bezier2"
                        }, null, 8, ["info-badge-description", "info-badge-title", "status"]))
                      : _createCommentVNode("", true)
                  ], 2)),
              (_ctx.hasCan)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(_ctx.windowWidth > 1500 ? 'col-sm-4' : 'col-sm-6')
                  }, [
                    _createVNode(_component_Card, {
                      badges: 2,
                      "info-badge-description": [_ctx.store.odometer_start + ' [km]', _ctx.store.odometer_stop + ' [km]'],
                      "info-badge-title": [_ctx.$t('components.history.summary.departure'), _ctx.$t('components.history.summary.arrival')],
                      status: _ctx.$t('components.history.summary.odometer'),
                      icon: "bi bi-signpost-2"
                    }, null, 8, ["info-badge-description", "info-badge-title", "status"])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.hasCan)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass(_ctx.windowWidth > 1500 ? 'col-sm-4' : 'col-sm-6')
                  }, [
                    _createVNode(_component_Card, {
                      badges: 3,
                      "info-badge-description": [_ctx.store.fuel_start + ' [L]', _ctx.store.fuel_stop + ' [L]', _ctx.store.fuel_used + ' [L]'],
                      "info-badge-title": [_ctx.$t('components.history.summary.departure'), _ctx.$t('components.history.summary.arrival'), _ctx.$t('components.history.summary.burned')],
                      status: _ctx.$t('components.history.summary.fuel'),
                      icon: "bi bi-droplet-half"
                    }, null, 8, ["info-badge-description", "info-badge-title", "status"])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.hasCan)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass(_ctx.windowWidth > 1500 ? 'col-sm-4' : 'col-sm-6')
                  }, [
                    _createVNode(_component_Card, {
                      badges: 2,
                      "info-badge-description": [_ctx.store.fuel_rate_map + ' [L/100]', _ctx.store.fuel_rate_can + ' [L/100]'],
                      "info-badge-title": [_ctx.$t('components.history.summary.byDistanceFromMap'), _ctx.$t('components.history.summary.byDistanceFromCan')],
                      status: _ctx.$t('components.history.summary.averageFuelRate'),
                      icon: "bi bi-graph-down"
                    }, null, 8, ["info-badge-description", "info-badge-title", "status"])
                  ], 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.windowWidth > 1500 || _ctx.delegationCountries.length > 3 ? 'col-sm-12' : 'col-sm-6')
              }, [
                _createVNode(_component_Card, {
                  badges: _ctx.delegationCountries.length,
                  "info-badge-description": _ctx.delegationTimes,
                  "info-badge-title": _ctx.delegationCountries,
                  status: _ctx.$t('components.history.summary.delegation'),
                  icon: "bi bi-globe"
                }, null, 8, ["badges", "info-badge-description", "info-badge-title", "status"])
              ], 2)
            ]))
          : (_ctx.flipped && _ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_ScaleLoader, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_DxDataGrid, {
                      key: 1,
                      ref: _ctx.dataGridRef[0],
                      "allow-column-reordering": true,
                      "allow-column-resizing": true,
                      "column-auto-width": true,
                      "column-hiding-enabled": true,
                      "data-source": _ctx.store.border_crossing,
                      "hover-state-enabled": true,
                      "remote-operations": _ctx.remoteOperations,
                      "row-alternation-enabled": true,
                      "show-borders": true,
                      "show-column-lines": true,
                      "show-row-lines": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxHeaderFilter, { visible: true }),
                        _createVNode(_component_DxPaging, {
                          "page-index": 0,
                          "page-size": 25
                        }),
                        _createVNode(_component_DxPager, {
                          "allowed-page-sizes": [10, 20, 25],
                          "show-info": true,
                          "show-navigation-buttons": true,
                          "show-page-size-selector": true
                        }),
                        _createVNode(_component_DxFilterRow, { visible: true }),
                        _createVNode(_component_DxColumnFixing, { enabled: true }),
                        _createVNode(_component_DxColumn, {
                          caption: _ctx.$t('components.history.summary.dataGrids.borderCrossing')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxColumn, {
                              "allow-filtering": true,
                              "allow-header-filtering": false,
                              caption: _ctx.$t('components.history.summary.dataGrids.fromCountry'),
                              "filter-operations": _ctx.allowedOperations,
                              "data-field": "from_country"
                            }, null, 8, ["caption", "filter-operations"]),
                            _createVNode(_component_DxColumn, {
                              "allow-filtering": true,
                              "allow-header-filtering": false,
                              caption: _ctx.$t('components.history.summary.dataGrids.toCountry'),
                              "filter-operations": _ctx.allowedOperations,
                              "data-field": "to_country"
                            }, null, 8, ["caption", "filter-operations"]),
                            _createVNode(_component_DxColumn, {
                              "allow-filtering": true,
                              "allow-header-filtering": false,
                              caption: _ctx.$t('components.history.summary.dataGrids.date'),
                              "filter-operations": _ctx.allowedOperations,
                              "data-field": "timestamp"
                            }, null, 8, ["caption", "filter-operations"]),
                            _createVNode(_component_DxColumn, {
                              "allow-filtering": true,
                              "allow-header-filtering": false,
                              caption: _ctx.$t('components.history.summary.dataGrids.distance'),
                              "filter-operations": _ctx.allowedOperations,
                              "data-field": "distance"
                            }, null, 8, ["caption", "filter-operations"]),
                            _createVNode(_component_DxColumn, {
                              "allow-filtering": true,
                              "allow-header-filtering": false,
                              caption: _ctx.$t('components.history.summary.dataGrids.place'),
                              "filter-operations": _ctx.allowedOperations,
                              "data-field": "place"
                            }, null, 8, ["caption", "filter-operations"])
                          ]),
                          _: 1
                        }, 8, ["caption"])
                      ]),
                      _: 1
                    }, 8, ["data-source", "remote-operations"])),
                _createVNode(_component_DxDataGrid, {
                  ref: _ctx.dataGridRef[1],
                  "data-source": _ctx.store.delegation_by_country,
                  "remote-operations": _ctx.remoteOperations,
                  "row-alternation-enabled": true,
                  "show-borders": true,
                  "show-column-lines": true,
                  "show-row-lines": false,
                  style: {"margin-bottom":"0"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxHeaderFilter, { visible: true }),
                    _createVNode(_component_DxPaging, {
                      "page-index": 0,
                      "page-size": 25
                    }),
                    _createVNode(_component_DxPager, {
                      "allowed-page-sizes": [10, 20, 25],
                      "show-info": true,
                      "show-navigation-buttons": true,
                      "show-page-size-selector": true
                    }),
                    _createVNode(_component_DxFilterRow, { visible: true }),
                    _createVNode(_component_DxColumnFixing, { enabled: true }),
                    _createVNode(_component_DxColumn, {
                      caption: _ctx.$t('components.history.summary.dataGrids.workingTimeByCountry')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.country'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "country"
                        }, null, 8, ["caption", "filter-operations"]),
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.arrival'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "arrival_timestamp"
                        }, null, 8, ["caption", "filter-operations"]),
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.departure'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "departure_timestamp"
                        }, null, 8, ["caption", "filter-operations"]),
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.timeOfVisit'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "time"
                        }, null, 8, ["caption", "filter-operations"]),
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.driving'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "drive_time",
                          width: "150"
                        }, null, 8, ["caption", "filter-operations"]),
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.otherWork'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "work_time",
                          width: "150"
                        }, null, 8, ["caption", "filter-operations"]),
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.breakAndRest'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "rest_time",
                          width: "150"
                        }, null, 8, ["caption", "filter-operations"])
                      ]),
                      _: 1
                    }, 8, ["caption"])
                  ]),
                  _: 1
                }, 8, ["data-source", "remote-operations"]),
                _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t('components.history.summary.dataGrids.sum')), 1),
                _createVNode(_component_DxDataGrid, {
                  ref: _ctx.dataGridRef[2],
                  "data-source": _ctx.store.delegation_by_country_sum,
                  "row-alternation-enabled": true,
                  "show-borders": true,
                  "show-column-headers": false,
                  "show-column-lines": true,
                  "show-row-lines": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxColumn, {
                      "allow-filtering": true,
                      "allow-header-filtering": false,
                      "filter-operations": _ctx.allowedOperations,
                      "data-field": "country"
                    }, null, 8, ["filter-operations"]),
                    _createVNode(_component_DxColumn, {
                      "allow-filtering": true,
                      "allow-header-filtering": false,
                      "filter-operations": _ctx.allowedOperations,
                      "data-field": "drive_time",
                      width: "150"
                    }, null, 8, ["filter-operations"]),
                    _createVNode(_component_DxColumn, {
                      "allow-filtering": true,
                      "allow-header-filtering": false,
                      "filter-operations": _ctx.allowedOperations,
                      "data-field": "work_time",
                      width: "150"
                    }, null, 8, ["filter-operations"]),
                    _createVNode(_component_DxColumn, {
                      "allow-filtering": true,
                      "allow-header-filtering": false,
                      "filter-operations": _ctx.allowedOperations,
                      "data-field": "rest_time",
                      width: "150"
                    }, null, 8, ["filter-operations"])
                  ]),
                  _: 1
                }, 8, ["data-source"]),
                _createVNode(_component_DxDataGrid, {
                  ref: _ctx.dataGridRef[3],
                  "allow-column-reordering": true,
                  "allow-column-resizing": true,
                  "column-auto-width": true,
                  "column-hiding-enabled": true,
                  "data-source": _ctx.store.gps_signal_loss,
                  "hover-state-enabled": true,
                  "remote-operations": _ctx.remoteOperations,
                  "row-alternation-enabled": true,
                  "show-borders": true,
                  "show-column-lines": true,
                  "show-row-lines": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxHeaderFilter, { visible: true }),
                    _createVNode(_component_DxPaging, {
                      "page-index": 0,
                      "page-size": 25
                    }),
                    _createVNode(_component_DxPager, {
                      "allowed-page-sizes": [10, 20, 25],
                      "show-info": true,
                      "show-navigation-buttons": true,
                      "show-page-size-selector": true
                    }),
                    _createVNode(_component_DxFilterRow, { visible: true }),
                    _createVNode(_component_DxColumnFixing, { enabled: true }),
                    _createVNode(_component_DxColumn, {
                      caption: _ctx.$t('components.history.summary.dataGrids.gpsSignalLoss')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.from'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "from"
                        }, null, 8, ["caption", "filter-operations"]),
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.to'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "to"
                        }, null, 8, ["caption", "filter-operations"]),
                        _createVNode(_component_DxColumn, {
                          "allow-filtering": true,
                          "allow-header-filtering": false,
                          caption: _ctx.$t('components.history.summary.dataGrids.duration'),
                          "filter-operations": _ctx.allowedOperations,
                          "data-field": "diff"
                        }, null, 8, ["caption", "filter-operations"])
                      ]),
                      _: 1
                    }, 8, ["caption"])
                  ]),
                  _: 1
                }, 8, ["data-source", "remote-operations"])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}